<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>

<ng-template #tableRowexpansion let-data> 
    <app-seguimiento-historial [actividadId]="data.id"></app-seguimiento-historial>
</ng-template>
